module.exports = __webpack_public_path__ + "static/media/krx-derivatives-seeds-02.45a67157.jpg";